var map = {
	"./alma.webp": 7928,
	"./boci.webp": 5236,
	"./buza.webp": 7955,
	"./kakas.webp": 1016,
	"./manifest": 4014,
	"./manifest.js": 4014,
	"./old/20250220-7D1_3201.webp": 56,
	"./old/20250220-7D1_3209.webp": 4448,
	"./old/20250220-7D1_3237.webp": 8233,
	"./old/20250220-7D1_3280.webp": 5459,
	"./old/20250220-7D1_3299.webp": 9521,
	"./old/20250220-7D1_3301.webp": 4451,
	"./old/20250220-7D1_3312.webp": 8659,
	"./old/20250220-7D1_3360.webp": 3434,
	"./old/20250220-7D1_3406.webp": 9035,
	"./old/20250220-7D1_3456.webp": 7518,
	"./old/20250220-7D1_3517.webp": 7742,
	"./old/20250220-7D1_3521.webp": 9387,
	"./old/20250220-7D1_3581.webp": 1105,
	"./old/20250220-7D1_3596.webp": 4977,
	"./old/20250220-7D1_3598.webp": 3123,
	"./old/20250220-7D1_3629.webp": 1846,
	"./old/20250220-7D1_3639.webp": 9671,
	"./old/20250220-7D1_3644.webp": 3167,
	"./old/20250220-7D1_3653.webp": 2063,
	"./old/20250220-7D1_3686.webp": 6429,
	"./old/_MG_3137-HDR.webp": 7022,
	"./old/_MG_3140-HDR.webp": 328,
	"./old/_MG_3148-HDR.webp": 3456,
	"./old/_MG_3201.webp": 9605,
	"./old/_MG_3217.webp": 3250,
	"./old/_MG_3219.webp": 8692,
	"./paprika.webp": 2317
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;